
import { useOnScrollHidden } from "@/hooks";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "ScrollTop",
  setup() {
    const hidden = ref(true);

    useOnScrollHidden(hidden, 120);

    const scrollTop = () => {
      window.scrollTo(0, 0);
    };

    return { scrollTop, hidden };
  },
});
